import Helper from "../modules/Helper";
import PropTypes from "prop-types";
import React from "react";
import {times} from "lodash";

const ProductRatingStars = (props) => {
  const {
    averageRating,
    forGrid
  } = props;
  const stars = [];
  let index = 0;
  const filledStars = Math.floor(averageRating);
  const hasHalfStar = averageRating % 1 === 0.5;
  const emptyStars = 5 - (filledStars + hasHalfStar);

  times(filledStars, () => {
    stars.push(
      <img
        alt="filled-star"
        className={forGrid ? "product-rating-star-grid" : "product-rating-star"}
        key={`product-rating-star-${index += 1}`}
        src={`${Helper.assetsUrl}/assets/roxy/feedback_page/product-ratings-star-filled.svg`}
      />
    );
  });

  if (hasHalfStar) {
    stars.push(
      <img
        alt="half-filled-star"
        className={forGrid ? "product-rating-star-grid" : "product-rating-star"}
        key={`product-rating-star-${index += 1}`}
        src={`${Helper.assetsUrl}/assets/roxy/feedback_page/product-ratings-star-half.svg`}
      />
    );
  }

  if (emptyStars) {
    times(emptyStars, () => {
      stars.push(
        <img
          alt="empty-star"
          className={forGrid ? "product-rating-star-grid" : "product-rating-star"}
          key={`product-rating-star-${index += 1}`}
          src={`${Helper.assetsUrl}/assets/roxy/feedback_page/product-ratings-star-empty.svg`}
        />
      );
    });
  }

  return (
    <div className="stars">
      {stars}
    </div>
  );
};

ProductRatingStars.propTypes = {
  "averageRating": PropTypes.number.isRequired,
  "forGrid": PropTypes.bool.isRequired
};

export default ProductRatingStars;
